import React from 'react'
import Video from 'components/video/video'
import TextQuestion from 'components/text-question/text-question'
import videoServices from 'services/video'
import { VideoType } from 'types'
import styled from 'styled-components'

interface QuestionProps {
  question: VideoType & { id?: string }
  className?: string
  title?: object | string
  children?: React.ReactNode | React.ReactNode[]
  textQuestion?: object | string
  draftMode?: boolean
  editMode?: boolean
  playable?: boolean
  timedInterview?: boolean
  updateState?: () => void
  locationId?: string
  eventId?: string
  videoEventProps?: object
}

function refreshPlaybackUrl(video: VideoType, useOpentokPreview: boolean) {
  return videoServices.fetchPlaybackUrl(video, useOpentokPreview)
}

const StyledQuestion = styled.div`
  position: relative;
`

export const Question = ({
  title,
  className = '',
  children,
  textQuestion,
  question,
  playable = true,
  draftMode = false,
  editMode = false,
  timedInterview = false,
  locationId,
  eventId,
  videoEventProps,
  updateState,
}: QuestionProps) => {
  const renderContent = () => {
    if (question.videoUrl) {
      return (
        <Video
          id={question.id || question._id}
          title={title || question.title}
          playbackVideoUrl={question.playbackVideoUrl}
          videoUrl={question.videoUrl}
          subtitles={question.subtitles}
          englishSubtitles={question.englishSubtitles}
          playable={playable}
          recorder={question.recorder}
          draftMode={draftMode}
          editMode={editMode}
          timedInterview={timedInterview}
          updateState={updateState}
          refreshPlaybackUrl={(useOpentokPreview: boolean) =>
            refreshPlaybackUrl(question, useOpentokPreview)
          }
          locationId={locationId}
          eventId={eventId}
          videoEventProps={videoEventProps}
        />
      )
    }
    if (question.textQuestion) {
      return (
        <TextQuestion editMode={editMode}>
          {textQuestion || question.textQuestion}
        </TextQuestion>
      )
    }
    return null
  }

  return (
    <StyledQuestion className={`question ${className}`}>
      {renderContent()}
      {children}
    </StyledQuestion>
  )
}

export default Question
